import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { renderFilter } from '../../../Shared/TextHelpers';
import { PracticeListPermissionsContext } from '../PracticesList';

function PracticeGroup({
    practiceGroupName,
    practiceCity,
    filter,
    practiceStateProvince,
}) {
    const { canSearchGroups } = useContext(PracticeListPermissionsContext);
    if (!canSearchGroups || practiceGroupName === null) return [];
    return (
        <>
            {(practiceCity || practiceStateProvince) && <br />}
            <span title="Practice Group">
                {practiceGroupName && <FontAwesomeIcon icon={faUsers} />}
                &nbsp; &nbsp;
                {renderFilter(practiceGroupName, filter)}
            </span>
        </>
    );
}

export default PracticeGroup;
